var getters = {
  nodeEnv: function nodeEnv(state) {
    return state.app.nodeEnv;
  },
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  windowHeight: function windowHeight(state) {
    return state.app.height;
  },
  systemType: function systemType(state) {
    return state.app.system;
  },
  adminUrl: function adminUrl(state) {
    return state.app.adminUrl;
  },
  dcmviwerurl: function dcmviwerurl(state) {
    return state.app.dcmviwerurl;
  },
  appInfo: function appInfo(state) {
    return state.app.appInfo;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  username: function username(state) {
    return state.user.username;
  },
  typeName: function typeName(state) {
    return state.user.typeName;
  },
  roleName: function roleName(state) {
    return state.user.roleName;
  },
  code: function code(state) {
    return state.user.code;
  },
  userid: function userid(state) {
    return state.user.userid;
  },
  groupid: function groupid(state) {
    return state.user.groupid;
  },
  doctype: function doctype(state) {
    return state.user.doctype;
  },
  hospitalid: function hospitalid(state) {
    return state.user.hospitalid;
  },
  partnershipid: function partnershipid(state) {
    return state.user.partnershipid;
  },
  showai: function showai(state) {
    return state.user.showai;
  },
  canedit: function canedit(state) {
    return state.user.canedit;
  },
  aiopen: function aiopen(state) {
    return state.user.aiopen;
  },
  tijianopen: function tijianopen(state) {
    return state.user.tijianopen;
  },
  forcerecord: function forcerecord(state) {
    return state.user.forcerecord;
  },
  mustcontent: function mustcontent(state) {
    return state.user.mustcontent;
  },
  needcloud: function needcloud(state) {
    return state.permission.needcloud;
  },
  needSign: function needSign(state) {
    return state.permission.needSign;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  loading: function loading(state) {
    return state.permission.loading;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  addRoutes: function addRoutes(state) {
    return state.permission.addRoutes;
  },
  rights: function rights(state) {
    return state.permission.rights;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  }
};
export default getters;